'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var EXPERIMENT_QUERY = 'experiment:query';
var EXPERIMENT_QUERY_ACTIVE_VARIANT = 'experiment:query:active-variant';
var EXPERIMENT_QUERY_VARIANT_ENABLED = 'experiment:query:variant-enabled';
var VWO_INSTANCE = 'vwo-instance';

exports.EXPERIMENT_QUERY = EXPERIMENT_QUERY;
exports.EXPERIMENT_QUERY_ACTIVE_VARIANT = EXPERIMENT_QUERY_ACTIVE_VARIANT;
exports.EXPERIMENT_QUERY_VARIANT_ENABLED = EXPERIMENT_QUERY_VARIANT_ENABLED;
exports.VWO_INSTANCE = VWO_INSTANCE;
